/*
* @Author: gujianghua
* @Date:   2020-02-20 16:31:21
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-02-21 13:52:36
*/
import { service } from '@/utils/request'

export default {
	// 列表
	getPageList(params) {
		return service({
			url: '/cloud/weixin/platform/activity/zhuchan/pages',
			method: 'get',
			params
		})
	},
	// 保存
	save(data) {
		return service({
			url: '/cloud/weixin/platform/activity/zhuchan/save',
			method: 'post',
			data
		})
	},
	// 上下架
	changeState(data) {
		return service({
			url: '/cloud/weixin/platform/activity/zhuchan/changeState?' + data,
			method: 'post'
		})
	},
	// 详情
	getDetail(params) {
		return service({
			url: '/cloud/weixin/platform/activity/zhuchan/details',
			method: 'get',
			params
		})
	},
	// 审核
	audit(data) {
		return service({
			url: '/cloud/weixin/platform/activity/zhuchan/check?' + data,
			method: 'post',
		})
	},

}


// WEBPACK FOOTER //
// ./src/api/operateManage/nurseCare.js